import React from 'react';

interface AttendeeGeographicDistributionHeaderProps {
    className?: string;
    children?: React.ReactNode;
}

/**
 * Section header for "Attendee Geographic Distribution" on Live Events tab.
 * Figma: node-id=21203-2620
 */
export const AttendeeGeographicDistributionHeader: React.FC<AttendeeGeographicDistributionHeaderProps> = ({
    className = '',
    children,
}) => {
    return (
        <div className={`flex flex-col gap-6 ${className}`}>
            <div className="flex justify-start items-center">
                <div className="flex flex-col justify-start items-start gap-2">
                    <h3
                        className="text-[#111827] dark:text-white text-[20px] font-bold leading-[28px]"
                        style={{ fontFamily: 'Nunito' }}
                    >
                        Attendee Geographic Distribution
                    </h3>
                    <p
                        className="text-[#4A5565] dark:text-gray-400 text-[14px] font-normal leading-[20px]"
                        style={{ fontFamily: 'Nunito' }}
                    >
                        See where your event attendees live
                    </p>
                </div>
            </div>
            {children}
        </div>
    );
};
